import { redirect } from '@remix-run/react'
import { ContextURLInfo } from '~/types/common_cio'

const prodUrl = ['career.io']

export type UrlInformation = {
  origin: string
  pathname: string
  href: string
  hostname: string
  searchParams: Record<string, string>
}

export type PageContext = {
  url: UrlInformation
}

export const previewRouteHandler = (url: URL) => {
  const searchParams = Object.fromEntries(url.searchParams)
  let preview = Object.prototype.hasOwnProperty.call(searchParams, 'preview')

  if (prodUrl.includes(url.hostname)) preview = false
  return { preview, searchParams }
}

export const prepareRobotsMetadata = (url: ContextURLInfo) => {
  if (['staging.career.io', 'beta.career.io'].includes(url?.hostname)) return 'noindex, nofollow'

  return undefined
}

export const preparePageContext = (url: URL) => {
  return {
    url: {
      origin: url.origin,
      pathname: url.pathname,
      href: url.href,
      hostname: url.hostname,
      searchParams: Object.fromEntries(url.searchParams),
    },
  } as PageContext
}

export const prepareRemixRequest = (request: Request) => {
  const url = new URL(
    request.url !== 'localhost' ? request.url.replace('http://', 'https://') : request.url,
  )

  const { pathname, search } = url
  if (pathname.endsWith('/') && pathname !== '/') {
    // Redirect to the same URL without a trailing slash
    throw redirect(`${pathname.slice(0, -1)}${search}`, 301)
  }

  return url
}
